/**
 * Converts a string to kebab-case format
 * @param text The string to convert to kebab-case
 * @returns The kebab-case string
 */
export function toKebabCase(text: string): string {
  // Handle undefined/null input safely
  if (!text || typeof text !== "string") {
    return ""
  }

  return text
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^\w\-]+/g, "") // Remove non-word chars (except hyphens)
    .replace(/\-\-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-+/, "") // Remove leading hyphens
    .replace(/-+$/, "") // Remove trailing hyphens
}

/**
 * Converts a kebab-case string back to readable format with capitalized words
 * @param kebabString The kebab-case string to convert
 * @returns The readable string with capitalized words
 */
export function fromKebabCase(kebabString: string): string {
  // Handle undefined/null input safely
  if (!kebabString || typeof kebabString !== "string") {
    return ""
  }

  return kebabString
    .replace(/-/g, " ") // Convert hyphens back to spaces
    .replace(/\b\w/g, l => l.toUpperCase()) // Capitalize first letter of each word
}
